import React, { useState } from 'react';
import { NavLink, useNavigate } from "react-router-dom"
import { useDispatch } from 'react-redux';
import { signup } from "../../actions/auth"
import { AiOutlineEyeInvisible } from 'react-icons/ai'
import loginImage from '../../image/login.png'
import { ToastContainer, toast } from 'react-toastify';


function Register() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [togglePassword, setTogglePassword] = useState(false)
    const handlePasswordClick = () => {
        setTogglePassword(!togglePassword)
    }
    const [loading, setLoading] = useState(false);

    const [values, setValues] = useState({
        firstName: "",
        lastName: "",
        email: "",
        isAdmin: 0,
        password: "",
        confirmPassword: '',
    })

    const handleChange = (ev) => {
        setValues({
            ...values,
            [ev.target.name]: ev.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const payload = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            isAdmin: values.isAdmin,
        }
        dispatch(signup(payload, setLoading, navigate, toast))

    }
    return (
        <div className='authentication'>
            <div className='formWrapper'>
                <div className="authTop">
                    <div className=''></div>
                    <div className='loginImage'><img src={loginImage} alt="loginImage" /></div>
                    <div className="authTitle">Signup to be an Admin</div>
                </div>
                <form onSubmit={handleSubmit} className="add-form regForm">
                    <div className='inputfield-div'>
                        <label htmlFor="name">First Name</label>
                        <input type="text" name="firstName" placeholder="First Name ...." value={values.firstName} required className='inputfield' onChange={handleChange} />
                    </div>
                    <div className='inputfield-div'>
                        <label htmlFor="name">Last  Name</label>
                        <input type="text" name="lastName" placeholder="Last Name ...." value={values.lastName} required className='inputfield' onChange={handleChange} />
                    </div>
                    <div className='inputfield-div'>
                        <label htmlFor="name">Email</label>
                        <input type="email" name="email" placeholder="Email ...." value={values.email} required className='inputfield' onChange={handleChange} />
                    </div>
                    <div className='inputfield-div'>
                        <label htmlFor="name">Password</label>
                        <input type={togglePassword ? "text" : "password"} name="password" placeholder="Password ...." value={values.password} required className='inputfield' onChange={handleChange} />
                        <span className='eye'>
                            <AiOutlineEyeInvisible className='icon' style={{ color: `${togglePassword ? '#f85a5a' : 'gray'}` }} onClick={handlePasswordClick} />
                        </span>
                    </div>
                    <div className='inputfield-div'>
                        <label htmlFor="name">Confirm Password</label>
                        <input type={togglePassword ? "text" : "password"} name="confirmPassword" placeholder="Confirm Password ...." value={values.confirmPassword} required className='inputfield' onChange={handleChange} />
                        <span className='eye'>
                            <AiOutlineEyeInvisible className='icon' style={{ color: `${togglePassword ? '#f85a5a' : 'gray'}` }} onClick={handlePasswordClick} />
                        </span>
                    </div>

                    {loading ?
                        <button type="submit" className='form-btn submitting' style={{ pointerEvents: 'none' }}>
                            <div class="spinner-grow spinner-grow-sm" role="status"></div>
                            <span>Submitting ...</span>
                        </button>
                        :
                        <button type="submit" className='form-btn'>Submit</button>
                    }

                    <div className='form-footer'>
                        <p>Already have an account? <NavLink to='/login' className='navlink'>Login</NavLink></p>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Register